import React from "react";
import { useTranslation } from "react-i18next";
import { Bell } from "lucide-react";
import AlertSystemSection from "../components/AlertSystemSection";
import CurrencySection from "../components/settings/CurrencySection";
import DailyBriefSection from "../components/settings/DailyBriefSection";
import DocumentReminderSection from "../components/settings/DocumentReminderSection";
import SlackChannelSection from "../components/settings/SlackChannelSection";
import { useWorkspace } from "../lib/WorkspaceContext";

/**
 * Settings → Notifications.
 *
 * Hosts the operational `AlertSystemSection` widget (scheduler status,
 * email-provider state, pending-preview send actions). Moved out of the
 * executive Dashboard so the dashboard stays CEO-grade — the heavy
 * operational chrome belongs in settings.
 */
export default function SettingsNotifications() {
  const { t } = useTranslation("common");
  const { currentId: workspaceId } = useWorkspace();
  return (
    <div className="animate-fade-up" data-testid="settings-notifications-page">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-2 inline-flex items-center gap-1.5">
            <Bell size={12} strokeWidth={1.75} />
            {t("nav.settings")}
          </p>
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-950">
            {t("settings.notifications.title")}
          </h1>
          <p className="text-sm text-zinc-500 mt-1.5 max-w-xl">
            {t("settings.notifications.subtitle")}
          </p>
        </div>
      </div>

      {workspaceId && <CurrencySection />}
      <DailyBriefSection />
      <DocumentReminderSection />
      {workspaceId && <SlackChannelSection workspaceId={workspaceId} />}
      <AlertSystemSection />
    </div>
  );
}
